module.exports = __webpack_public_path__ + "static/media/hero-image.4c248c90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero-image.jpg
// module id = 27
// module chunks = 0